import { useForm, formRootRule, isNotEmpty } from '@mantine/form';

import { useShowResponseStatus } from '@/shared';
import { useUpdatePaymentMethodCredentialsMutation } from '../store/payment-methods-api';
import { useGetShops } from '@/modules/shops';

import type { TPaymentMethodUpdateCredentialsParams, TPaymentMethodCredential } from '../store/types';

type FormData = Omit<TPaymentMethodUpdateCredentialsParams, 'shopId'> & {
  shopId?: string;
};

type Params = {
  credentials: TPaymentMethodCredential;
  onClose: () => void;
};

export const useUpdateMethodCredentials = ({ credentials, onClose }: Params) => {
  const [updateMethodCredential, {
    isLoading: isUpdateLoading,
    isSuccess,
    isError,
  }] = useUpdatePaymentMethodCredentialsMutation();

  const {
    data: shops,
    isLoading: isShopsLoading,
  } = useGetShops('regular');

  const isLoading = isUpdateLoading || isShopsLoading;

  const initialValues: FormData = {
    credentialsId: credentials.id,
    fields: credentials.fields,
    validFor: credentials.validFor,
    limit: credentials.limit,
    shopId: credentials.shopId?.toString(),
    forPayerId: credentials.forPayerId,
    exceptPayerId: credentials.exceptPayerId,
  };

  const form = useForm<FormData>({
    mode: 'uncontrolled',
    // initialValues: { ...JSON.parse(JSON.stringify(initialValues)) },
    initialValues,
    validate: {
      fields: {
        [formRootRule]: isNotEmpty('Добавьте хотябы один реквизит'),
        name: isNotEmpty('Введите заголовок реквизита'),
        value: isNotEmpty('Введите значение реквизита')
      },
      validFor: isNotEmpty('Выберите способы оплаты'),
    },
  });

  useShowResponseStatus({
    isSuccess,
    successMessage: 'Реквизиты успешно обновлены',
    isError,
    errorMassage: 'При обновлении реквизитов произошла ошибка',
  });

  const handleSubmit = async (values: FormData) => {
    const newValues: TPaymentMethodUpdateCredentialsParams = {
      ...values,
      shopId: Number(values.shopId),
    };

    await updateMethodCredential(newValues);
    onClose();
  };

  return {
    shops,
    form,
    isLoading,
    handleSubmit,
    updateMethodCredential,
  };
};
